webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Helpers = {
    isMobile: function isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check || this.isIPAD() || window.innerWidth < 769;
    },
    isTouch: function isTouch() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
        return isMobile;
    },
    iOS: function iOS() {
        var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    },
    isIPAD: function isIPAD() {
        var ua = navigator.userAgent;
        return (/iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua)
        );
    },
    get_browser_info: function get_browser_info() {
        var ua = navigator.userAgent,
            tem = void 0,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE ', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: 'Opera', version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    },
    getRandomInt: function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomFromArray: function getRandomFromArray(array) {
        return array[getRandomInt(0, array.length - 1)];
    },
    declension: function declension(num, expressions) {
        var result = void 0;
        var count = num % 100;
        if (count >= 5 && count <= 20) {
            result = expressions['2'];
        } else {
            count = count % 10;
            if (count == 1) {
                result = expressions['0'];
            } else if (count >= 2 && count <= 4) {
                result = expressions['1'];
            } else {
                result = expressions['2'];
            }
        }
        return result;
    },
    isIE: function isIE() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('Edge/') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0) {
            return true;
        } else {
            return false;
        }
    },
    ga: function (_ga) {
        function ga() {
            return _ga.apply(this, arguments);
        }

        ga.toString = function () {
            return _ga.toString();
        };

        return ga;
    }(function () {
        var analitics = {
            send: function send(category, action, label, id) {
                if (typeof ga !== 'undefined') {

                    if (typeof label !== 'undefined' && label !== '') {
                        if (id) ga('send', 'event', category, action, label, id);else ga('send', 'event', category, action, label);
                    } else {
                        ga('send', 'event', category, action);
                    }
                }
            }
        };
        return analitics;
    }),
    share: function share(network, link, callback) {
        switch (network) {
            case "vk":
                sharePopup("https://vk.com/share.php?url=" + link, 550, 300, callback);
                break;
            case "fb":
                sharePopup('https://www.facebook.com/sharer/sharer.php?u=' + link, 550, 300, callback);
                break;
            case "tw":
                sharePopup("https://twitter.com/intent/tweet?original_referer=" + link + "&tw_p=tweetbutton&url=" + link, 550, 300, callback);
                break;
            case "ok":
                sharePopup("https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.shareUrl=" + link, 550, 300, callback);
                break;
            case "tg":
                sharePopup("https://telegram.me/share/url?url=" + link, 550, 300, callback);
                break;
        }

        function sharePopup(url, width, height, callback) {
            //  console.log(url);
            if (!width) width = 400;
            if (!height) height = 400;

            var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');
            var uri_regex = new RegExp(window.location.host);
            //console.log('document.location.host',document.location.host)
            var watch_timer = setInterval(function () {
                if (share_window.closed) {
                    clearInterval(watch_timer);
                    if (typeof callback != 'undefined') {
                        callback();
                    }
                    return;
                }
            }, 200);
        }
    },

    isScrolledIntoView: function isScrolledIntoView(el) {
        var elemTop = el.getBoundingClientRect().top;
        var elemBottom = el.getBoundingClientRect().bottom;
        var elHeight = elemBottom - elemTop;
        //return (elemTop >= -window.innerHeight/2) && (elemTop <= window.innerHeight/2) && (elemBottom >= window.innerHeight/2) && (elemBottom <= 3*window.innerHeight/2);
        return elemBottom <= elHeight;
    },

    dLayer: function dLayer(data) {
        if ('dataLayer' in window) {
            dataLayer.push(data);
        }
    },

    getOS: function getOS() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    },
    isMac: function isMac() {
        return this.getOS() === 'Mac OS';
    },
    getLang: function getLang() {
        var lang = localStorage.getItem('DEVELUP_LANG');
        var browserLang = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
        browserLang = browserLang.indexOf('ru') >= 0 ? 'ru' : 'en';
        return lang ? lang : browserLang;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Helpers);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(202),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(191),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z"/></svg>'};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.701 18.771h1.437s.433-.047.654-.284c.21-.221.21-.63.21-.63s-.031-1.927.869-2.21c.887-.281 2.012 1.86 3.211 2.683.916.629 1.605.494 1.605.494l3.211-.044s1.682-.105.887-1.426c-.061-.105-.451-.975-2.371-2.76-2.012-1.861-1.742-1.561.676-4.787 1.469-1.965 2.07-3.166 1.875-3.676-.166-.48-1.26-.361-1.26-.361l-3.602.031s-.27-.031-.465.09c-.195.119-.314.391-.314.391s-.572 1.529-1.336 2.82c-1.623 2.729-2.268 2.879-2.523 2.699-.604-.391-.449-1.58-.449-2.432 0-2.641.404-3.75-.781-4.035-.39-.091-.681-.15-1.685-.166-1.29-.014-2.378.01-2.995.311-.405.203-.72.652-.539.675.24.03.779.146 1.064.537.375.506.359 1.636.359 1.636s.211 3.116-.494 3.503c-.495.262-1.155-.28-2.595-2.756-.735-1.26-1.291-2.67-1.291-2.67s-.105-.256-.299-.406c-.227-.165-.557-.225-.557-.225l-3.435.03s-.51.016-.689.24c-.166.195-.016.615-.016.615s2.686 6.287 5.732 9.453c2.79 2.902 5.956 2.715 5.956 2.715l-.05-.055z"/></svg>'};

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);


var requireModule = __webpack_require__(570);
var modules = {};

requireModule.keys().forEach(function (fileName) {
    if (fileName === './index.js') return;
    var moduleName = __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()(fileName.replace(/(\.\/|\.svg)/g, ''));
    modules[moduleName] = requireModule(fileName);
});

/* harmony default export */ __webpack_exports__["a"] = (modules);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Behavior__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Types__ = __webpack_require__(130);





var PathMover = function () {
    function PathMover(path, options) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PathMover);

        this._svgPath = path;
        this._totalPathLen = ~~this._svgPath.getTotalLength();
        this._currentLen = 0;
        this._prevPercent = 0;

        this._width = options.width;
        this._height = options.height;

        this._updatePathBehavior = this.changeUpdatePathBehavior(options.updatePathBehavior);
        this._backwardDirectionBehavior = this.changeBackWardDirectionBehavior(options.backwardDirectionBehavior);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PathMover, [{
        key: "updatePath",
        value: function updatePath(value) {
            this._updatePathBehavior.updatePath(value);

            var POINT = this._svgPath.getPointAtLength(this._currentLen);
            var X = ~~(POINT.x - this._width / 2);
            var Y = ~~(POINT.y - this._height / 2);
            var PREV_POINT = this._svgPath.getPointAtLength(this._currentLen - 1);
            var X1 = POINT.y - PREV_POINT.y;
            var X2 = POINT.x - PREV_POINT.x;
            var angle = Math.atan(X1 / X2) * (180 / Math.PI);

            angle = this._checkNegativeAngle(angle);
            angle = this._calculateBakwardDirection(value, angle);

            this._prevPercent = value;

            return { x: X, y: Y, angle: angle };
        }
    }, {
        key: "changeUpdatePathBehavior",
        value: function changeUpdatePathBehavior(behaviorType) {
            switch (behaviorType) {
                case __WEBPACK_IMPORTED_MODULE_3__Types__["UpdatePathBehaviorType"].ByPercentage:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["a" /* UpdatePathByPercentageBehavior */](this);
                case __WEBPACK_IMPORTED_MODULE_3__Types__["UpdatePathBehaviorType"].ByConstantValue:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["b" /* UpdatePathByConstantValueBehavior */](this);
                default:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["b" /* UpdatePathByConstantValueBehavior */](this);
            }
        }
    }, {
        key: "changeBackWardDirectionBehavior",
        value: function changeBackWardDirectionBehavior(behaviorType) {
            switch (behaviorType) {
                case __WEBPACK_IMPORTED_MODULE_3__Types__["BackwardDirectionBehaviorType"].Calculate:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["c" /* CalculateBackwardDirectionBehavior */](this);
                case __WEBPACK_IMPORTED_MODULE_3__Types__["BackwardDirectionBehaviorType"].DontCalculate:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["d" /* DontCalculateBackwardDirectionBehavior */](this);
                default:
                    return new __WEBPACK_IMPORTED_MODULE_2__Behavior__["c" /* CalculateBackwardDirectionBehavior */](this);
            }
        }
    }, {
        key: "_checkNegativeAngle",
        value: function _checkNegativeAngle(angle) {
            if (angle < 0) {
                angle = angle + 180;
            }

            return angle;
        }
    }, {
        key: "_calculateBakwardDirection",
        value: function _calculateBakwardDirection(position, angle) {
            return this._backwardDirectionBehavior.calculateBakwardDirection(position, angle);
        }
    }]);

    return PathMover;
}();

/* harmony default export */ __webpack_exports__["a"] = (PathMover);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UpdatePathBehaviorType__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackwardDirectionBehaviorType__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UpdatePathBehaviorType", function() { return __WEBPACK_IMPORTED_MODULE_0__UpdatePathBehaviorType__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BackwardDirectionBehaviorType", function() { return __WEBPACK_IMPORTED_MODULE_1__BackwardDirectionBehaviorType__["a"]; });





/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
// Default State
var state = {
    currentId: 0,
    popup: '',
    isActive: false,
    scrollPercentage: 0
};

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typograf__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typograf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_typograf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuebar__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_Helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_share__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_plugins_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_DPlayer_dist_DPlayer_min_css__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_DPlayer_dist_DPlayer_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_DPlayer_dist_DPlayer_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_app_scss__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_scss_app_scss__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default.a);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */], {
    locale: 'ru',
    dictionary: {
        en: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* dictionary */].en,
        ru: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* dictionary */].ru
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__components_ui_plugins_js__["a" /* RouterItem */]);
var Tp = new __WEBPACK_IMPORTED_MODULE_4_typograf___default.a({ locale: ['ru', 'en-US'] });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('typograph', {
    bind: function bind(el, binding, vnode) {
        el.innerHTML = Tp.execute(el.innerHTML);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__tools_share__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    created: function created() {
        var _this = this;

        window.vue = this;
        this.$on('onResize', function () {
            var classList = document.body.classList;
            var mClassName = 'mobile';
            if (__WEBPACK_IMPORTED_MODULE_8__tools_Helpers__["a" /* default */].isMobile()) {
                classList.add(mClassName);
                _this.isMobile = true;
            } else {
                classList.remove(mClassName);
                _this.isMobile = false;
            }
        });
    },
    data: function data() {
        return {
            isMobile: __WEBPACK_IMPORTED_MODULE_8__tools_Helpers__["a" /* default */].isMobile(),
            gaSend: __WEBPACK_IMPORTED_MODULE_8__tools_Helpers__["a" /* default */].ga().send
        };
    },

    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Resize__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Menu__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_logo_svg__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_social_svg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_social_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_social_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_social__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_social_vk_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_social_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_social_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_social_fb_new_svg__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_social_fb_new_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_svg_social_fb_new_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            openMenu: false,
            openSocial: false
        };
    },


    components: {
        vk: __WEBPACK_IMPORTED_MODULE_5__assets_svg_social__["a" /* default */].vk,
        fb: __WEBPACK_IMPORTED_MODULE_7__assets_svg_social_fb_new_svg___default.a,
        ok: __WEBPACK_IMPORTED_MODULE_5__assets_svg_social__["a" /* default */].ok,
        googleplus: __WEBPACK_IMPORTED_MODULE_5__assets_svg_social__["a" /* default */].googleplus,
        tw: __WEBPACK_IMPORTED_MODULE_5__assets_svg_social__["a" /* default */].tw,
        Logo: __WEBPACK_IMPORTED_MODULE_3__assets_svg_logo_svg___default.a,
        'menu-app': __WEBPACK_IMPORTED_MODULE_2__components_common_Menu___default.a,
        Resize: __WEBPACK_IMPORTED_MODULE_1__components_common_Resize___default.a,
        opensocial: __WEBPACK_IMPORTED_MODULE_4__assets_svg_social_svg___default.a
    },

    computed: {
        popup: function popup() {
            return this.$store.getters['GET_POPUP'];
        }
    },

    mounted: function mounted() {},


    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_8__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        closeShare: function closeShare() {
            this.openSocial = false;
        },
        toggleMenu: function toggleMenu() {
            this.openMenu = !this.openMenu;
        },
        toggleSocial: function toggleSocial() {
            this.openSocial = !this.openSocial;
            this.gaEvents('main', 'click', 'heart');
        }
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup',
    data: function data() {
        return {
            active: '',
            formErrors: [],
            email: '',
            shows: false,
            show: true
        };
    },

    props: {
        showForm: {
            type: [Boolean],
            required: false,
            default: true
        },
        showCloseMobile: {
            type: [Boolean],
            required: false,
            default: false
        }
    },

    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        sub: function sub() {
            this.active = this.$store.getters['SET_FORM'];
            this.$store.commit('SET_FORM', !this.active);
        },
        check: function check(e) {
            var _this = this;

            this.gaEvents('main', 'click', 'sent e-mail');

            this.formErrors = [];
            if (!this.email) {
                this.formErrors.push("Укажите электронную почту.");
            } else if (!this.validEmail(this.email)) {
                this.formErrors.push("Укажите корректный адрес электронной почты.");
            }

            var data = {
                email: this.email
            };

            if (!this.formErrors.length) {
                this.$store.dispatch('SEND_FORM', data).then(function (result) {
                    _this.shows = true;
                });

                return true;
            }

            e.preventDefault();
        },
        validEmail: function validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        close: function close() {
            this.$emit('closeForm');
            this.gaEvents('main', 'click', 'close popup');
        }
    },

    computed: {
        getStatus: function getStatus() {
            return this.$store.getters['SET_FORM'];
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Form__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Menu',
    data: function data() {
        return {
            menu: [{
                id: 0,
                name: 'О проекте',
                route: '/',
                element: 'index',
                gaEvent: 'index'
            }, {
                id: 1,
                name: 'Путешествие',
                route: '/main',
                element: 'main',
                gaEvent: 'main'
            }, {
                id: 2,
                name: 'Места силы',
                route: '/point1',
                element: 'point1',
                gaEvent: 'point1'
            }, {
                id: 3,
                name: 'Пора на пикник!',
                route: '/picnic',
                element: 'picnic',
                gaEvent: 'picnic'
            }],
            showForm: true
        };
    },

    components: {
        Form: __WEBPACK_IMPORTED_MODULE_0__components_common_Form___default.a
    },
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        toogleMenu: function toogleMenu(route) {
            this.$emit('closeMenu');

            this.gaEvents('menu', 'click', route);
        },
        close: function close() {
            this.showForm = false;
        }
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


var defaultWidth = 1400,
    defaultFont = 16,
    minWidth = 768,
    minHeight = 600,
    defaultHeight = 800;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Resize',
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize.bind(this));
        this.$root.$emit('onResize');
    },
    data: function data() {
        return {
            vW: window.innerWidth,
            vH: window.innerHeight,
            ratio: 1
        };
    },


    computed: {
        fSize: function fSize() {
            var fSize = 16;
            if (!this.$root.isMobile) {
                fSize = 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
                this.ratio = Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
            }
            return fSize;
        }
    },

    methods: {
        onResize: function onResize() {
            this.$root.$emit('onResize');
            this.vW = window.innerWidth;
            this.vH = window.innerHeight;
        }
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_first__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_parts_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_pageMain__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_pageMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_pageMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_points_point1__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_points_point1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_points_point1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_points_point2__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_points_point2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_points_point2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_points_point3__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_points_point3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_points_point3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_points_point4__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_points_point4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_points_point4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_points_point5__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_points_point5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_points_point5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_parts_competition__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_parts_competition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_parts_competition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_parts_last__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_parts_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_parts_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_popups_popup1__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_popups_popup1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_popups_popup1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_popups_popup2__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_popups_popup2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_popups_popup2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_popups_popup3__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_popups_popup3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_popups_popup3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_popups_popup4__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_popups_popup4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pages_popups_popup4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_popups_popup5__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_popups_popup5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pages_popups_popup5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_parts_pathAirPlane__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_parts_pathAirPlane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_parts_pathAirPlane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_parts_PathMover__ = __webpack_require__(217);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Index',
    data: function data() {
        return {
            scrollTop: 0,
            pageHeight: 0,
            path: '',
            dot: '',
            firstScrolled: false,
            scroll25: false,
            scroll50: false,
            scroll75: false,
            scroll100: false
        };
    },

    components: {
        first: __WEBPACK_IMPORTED_MODULE_2__components_parts_first___default.a,
        pageMain: __WEBPACK_IMPORTED_MODULE_3__components_parts_pageMain___default.a,
        point1: __WEBPACK_IMPORTED_MODULE_4__components_pages_points_point1___default.a,
        point2: __WEBPACK_IMPORTED_MODULE_5__components_pages_points_point2___default.a,
        point3: __WEBPACK_IMPORTED_MODULE_6__components_pages_points_point3___default.a,
        point4: __WEBPACK_IMPORTED_MODULE_7__components_pages_points_point4___default.a,
        point5: __WEBPACK_IMPORTED_MODULE_8__components_pages_points_point5___default.a,
        competition: __WEBPACK_IMPORTED_MODULE_9__components_parts_competition___default.a,
        last: __WEBPACK_IMPORTED_MODULE_10__components_parts_last___default.a,
        popup1: __WEBPACK_IMPORTED_MODULE_11__components_pages_popups_popup1___default.a,
        popup2: __WEBPACK_IMPORTED_MODULE_12__components_pages_popups_popup2___default.a,
        popup3: __WEBPACK_IMPORTED_MODULE_13__components_pages_popups_popup3___default.a,
        popup4: __WEBPACK_IMPORTED_MODULE_14__components_pages_popups_popup4___default.a,
        popup5: __WEBPACK_IMPORTED_MODULE_15__components_pages_popups_popup5___default.a,
        pathAirPlane: __WEBPACK_IMPORTED_MODULE_16__components_parts_pathAirPlane___default.a

    },
    mounted: function mounted() {
        if (this.$route.name == 'index') {
            this.scrollToTop();
        } else {
            this.firstScrolled = true;
        }
        this.$nextTick(function () {
            this.$refs['pageIndex'].classList.add('show');
        });

        this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
        this.scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
        this.pageHeight = document.querySelector('#scrollBar').scrollHeight;

        var SVG_PATH = this.$refs['svgPathEl'].$refs['svgPath'].$el.children[0];

        this._pathMover = new __WEBPACK_IMPORTED_MODULE_17__components_parts_PathMover__["a" /* PathMover */](SVG_PATH, {
            width: 62,
            height: 62,
            backwardDirectionBehavior: __WEBPACK_IMPORTED_MODULE_17__components_parts_PathMover__["b" /* PathMoverTypes */].BackwardDirectionBehaviorType.Calculate,
            updatePathBehavior: __WEBPACK_IMPORTED_MODULE_17__components_parts_PathMover__["b" /* PathMoverTypes */].UpdatePathBehaviorType.ByPercentage
        });

        this.animatedImages = document.querySelectorAll('.animate-img, .animate-block, .quotes');

        this.path = this.$refs['svgPathEl'].$el.childNodes[0].children[0];

        this.dot = this.$refs['svgPathEl'];

        //Height path
        var PathScreen = this.$refs['svgPathEl'].$el;

        var trueHeight = this.pageHeight - window.innerHeight;

        PathScreen.style.height = trueHeight + 'px';
    },

    methods: {
        scrollToTop: function scrollToTop() {
            this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
        },
        checkBlock: function checkBlock(block) {
            return block.getBoundingClientRect().top >= -window.innerHeight / 2 && block.getBoundingClientRect().top < window.innerHeight / 2;
        },
        getPageRoute: function getPageRoute(id) {
            return id === 'index' ? '/' : '/' + id;
        },
        scrollToNext: function scrollToNext() {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(this.$refs['scrollBar'], .4, { scrollTop: document.getElementById('main').getBoundingClientRect().top + this.$refs['scrollBar'].scrollTop });
        },
        onScroll: function onScroll(e) {
            //let block = document.querySelectorAll('.animate-img, .animate-block, .quotes');
            var LEN = this.animatedImages.length;
            for (var i = 0; i < LEN; i++) {
                if (this.checkBlock(this.animatedImages[i])) {
                    this.animatedImages[i].classList.add('show');
                }
            }
            if (!this.firstScrolled) {
                if (this.$route.name === 'index') {
                    this.firstScrolled = true;
                    this.scrollToNext();
                }
            }

            var SCROLL_TOP = e.target.scrollTop;
            var SCROLL_DATA = this.getScrollData(SCROLL_TOP);
            this.updatePositions(SCROLL_DATA.percentage);
            //this.$store.commit("SET_SCROLL_PERCENTAGE", PERCENTAGE);

            var pages = document.querySelectorAll('.page');
            var currentPage = pages[0];
            for (var _i = 0; _i < pages.length; _i++) {
                if (this.checkBlock(pages[_i])) {
                    currentPage = pages[_i];
                    this.$router.push(this.getPageRoute(currentPage.id));
                    break;
                }
            }
            this.scrollTop = e.target.scrollTop;
            this.windowHeight = window.innerHeight;
            // start gaEvent Scroll

            var scrollPercent = Math.round(this.scrollTop / (this.pageHeight - this.windowHeight) * 100);
            if (scrollPercent >= 25 && !this.scroll25) {
                this.$root.gaSend('main', 'scroll', '25%');
                this.scroll25 = true;
            }
            if (scrollPercent >= 50 && !this.scroll50) {
                this.$root.gaSend('main', 'scroll', '50%');
                this.scroll50 = true;
            }
            if (scrollPercent >= 75 && !this.scroll75) {
                this.$root.gaSend('main', 'scroll', '75%');
                this.scroll75 = true;
            }
            if (scrollPercent >= 90 && !this.scroll100) {
                this.$root.gaSend('main', 'scroll', '100%');
                this.scroll100 = true;
            }
            // finish gaEvent Scroll
        },
        getScrollData: function getScrollData(scrollTop) {

            if (this.$root.isMobile === false) {
                var EL = this.$refs['svgPathEl'].$refs['svgPath'].$el;
                var BOUNDING_BOX = EL.getBoundingClientRect();
                var EL_HEIGHT = BOUNDING_BOX.height;
                var WINDOW_HEIGHT = window.innerHeight;
                var TOP = BOUNDING_BOX.y;
                var PERCENTAGE = -(TOP / (EL_HEIGHT - WINDOW_HEIGHT));

                return { percentage: PERCENTAGE, top: TOP };
            } else {
                return { percentage: 0, top: 0 };
            }
        },
        updatePositions: function updatePositions(percentage) {
            if (this.$root.isMobile === false) {
                // const TEST_PLANE = this.$refs['testPlane'];
                var TEST_PLANE = this.$refs['svgPathEl'].$refs['svgPath'].$el.querySelector('.ap');
                var OBJET_POS = this._pathMover.updatePath(percentage);
                var X = OBJET_POS.x;
                var Y = OBJET_POS.y;
                var ANGLE = OBJET_POS.angle;

                TEST_PLANE.setAttribute('transform', 'translate(' + X + ', ' + Y + ') rotate(' + (ANGLE || 0) + ' ' + 32 + ' ' + 32 + ')');
            }
        }
    },
    computed: {
        popup: function popup() {
            return this.$store.getters['GET_POPUP'];
        }
    }

});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_DPlayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'article1',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default.a],
    data: function data() {
        return {
            isPlaying: false,
            player: ''
        };
    },
    mounted: function mounted() {},

    methods: {
        ready: function ready(e) {
            this.canPlay = true;
            this.player = e.target;
        },
        ended: function ended() {
            this.isPlaying = false;
        },
        playVideo: function playVideo() {
            this.isPlaying = true;
            if (this.canPlay) {
                this.$root.gaSend('play', 'click', 'longread 1');
                this.player.playVideo();
            }
        }
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_DPlayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'article2',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default.a],
    data: function data() {
        return {
            isPlaying: false,
            player: ''
        };
    },

    methods: {
        ready: function ready(e) {
            this.canPlay = true;
            this.player = e.target;
        },
        ended: function ended() {
            this.isPlaying = false;
        },
        playVideo: function playVideo() {
            this.isPlaying = true;
            if (this.canPlay) {
                this.$root.gaSend('play', 'click', 'longread 2');
                this.player.playVideo();
            }
        }
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_DPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_DPlayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'article3',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__components_pages_articles_article_mix_vue___default.a],
    data: function data() {
        return {
            isPlaying: false,
            player: ''
        };
    },

    methods: {
        ready: function ready(e) {
            this.canPlay = true;
            this.player = e.target;
        },
        ended: function ended() {
            this.isPlaying = false;
        },
        playVideo: function playVideo() {
            this.isPlaying = true;
            if (this.canPlay) {
                this.$root.gaSend('play', 'click', 'longread 3');
                this.player.playVideo();
            }
        }
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_share_svg__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_share_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_social__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_social_vk_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_social_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_social_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_social_fb_new_svg__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_social_fb_new_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_social_fb_new_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'articleMix',
    data: function data() {
        return {
            openSocial: false,
            swiperOption: {
                slidesPerView: 'auto',
                centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    769: {
                        spaceBetween: 0,
                        loop: true
                    }
                },
                on: {
                    slideChange: function slideChange() {
                        __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].ga().send('longread', 'click', 'slide');
                    },
                    click: function click() {
                        var Clickindex = this.clickedIndex;

                        if (this.activeIndex === Clickindex + 1) {
                            this.slidePrev();
                        } else if (this.activeIndex === Clickindex - 1) {
                            this.slideNext();
                        }
                    }
                }
            },

            swiperProductOption: {
                slidesPerView: 1,
                centeredSlides: true,
                autoHeight: true,
                hideOnClick: true,
                pagination: {
                    el: '.swiper-pagination'
                }
            },

            scrollTop: 0,
            pageHeight: 0,
            firstScrolled: false,
            scroll25: false,
            scroll50: false,
            scroll75: false,
            scroll100: false,
            nextFlag: false
        };
    },


    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiperSlide"],
        vk: __WEBPACK_IMPORTED_MODULE_3__assets_svg_social__["a" /* default */].vk,
        fb: __WEBPACK_IMPORTED_MODULE_5__assets_svg_social_fb_new_svg___default.a,
        ok: __WEBPACK_IMPORTED_MODULE_3__assets_svg_social__["a" /* default */].ok,
        googleplus: __WEBPACK_IMPORTED_MODULE_3__assets_svg_social__["a" /* default */].googleplus,
        tw: __WEBPACK_IMPORTED_MODULE_3__assets_svg_social__["a" /* default */].tw,
        opensocial: __WEBPACK_IMPORTED_MODULE_2__assets_svg_share_svg___default.a
    },

    methods: {
        controls: function controls(e) {
            var videoTag = this.$refs['video'];
            var btn = e.target;

            if (videoTag.paused === true) {
                videoTag.play();
                btn.classList.remove('btn-pause');
                btn.classList.add('btn-play');
            } else {
                videoTag.pause();
                btn.classList.remove('btn-play');
                btn.classList.add('btn-pause');
            }
        },
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        scrollToTop: function scrollToTop() {
            this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
        },
        checkBlock: function checkBlock(block) {
            return block.getBoundingClientRect().top >= -window.innerHeight / 2 && block.getBoundingClientRect().top < window.innerHeight / 2;
        },
        getPageRoute: function getPageRoute(id) {
            return id === 'index' ? '/' : '/' + id;
        },
        onScroll: function onScroll(e) {
            var block = document.querySelectorAll('.animate-img, .animate-block, .quotes');
            for (var i = 0; i < block.length; i++) {
                if (this.checkBlock(block[i])) {
                    block[i].classList.add('show');
                }
            }

            // start gaEvent Scroll
            var scrollTop = e.target.scrollTop;
            var windowHeight = window.innerHeight;

            var scrollPercent = Math.round(scrollTop / (this.pageHeight - windowHeight) * 100);
            var ResScrollPercent = Math.abs(scrollPercent);

            if (ResScrollPercent >= 25 && !this.scroll25) {
                this.$root.gaSend('longread', 'scroll', '25%');
                this.scroll25 = true;
            }
            if (ResScrollPercent >= 50 && !this.scroll50) {
                this.$root.gaSend('longread', 'scroll', '50%');
                this.scroll50 = true;
            }
            if (ResScrollPercent >= 75 && !this.scroll75) {
                this.$root.gaSend('longread', 'scroll', '75%');
                this.scroll75 = true;
            }
            if (ResScrollPercent >= 100 && !this.scroll100) {
                this.$root.gaSend('longread', 'scroll', '100%');
                this.scroll100 = true;
            }
            // finish gaEvent Scroll
        },
        closeShare: function closeShare() {
            this.openSocial = false;
        },
        toggleSocial: function toggleSocial() {
            this.openSocial = !this.openSocial;
            this.gaEvents('main', 'click', 'share');
        }
    },
    mounted: function mounted() {
        this.scrollToTop();
        this.pageHeight = document.querySelector('#scrollBar').scrollHeight;

        // let videoTag = this.$refs['video'];
        // let seekBar = this.$refs['range'];
        //
        // seekBar.addEventListener("change", function() {
        //     let time = videoTag.duration * (seekBar.value / 100);
        //     videoTag.currentTime = time;
        // });
        //
        // videoTag.addEventListener("timeupdate", function() {
        //     let value = (100 / videoTag.duration) * videoTag.currentTime;
        //     seekBar.value = value;
        // });
        //
        // seekBar.addEventListener("mousedown", function() {
        //     videoTag.pause();
        // });
        //
        // seekBar.addEventListener("mouseup", function() {
        //     videoTag.play();
        // });
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'point1',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        openPopup: function openPopup() {
            this.$store.commit('SET_POPUP', 'popup1');
            this.gaEvents('places', 'click', 'show 1');
        }
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'point2',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        openPopup: function openPopup() {
            this.$store.commit('SET_POPUP', 'popup2');
            this.gaEvents('places', 'click', 'show 2');
        }
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'point3',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        openPopup: function openPopup() {
            this.$store.commit('SET_POPUP', 'popup3');
            this.gaEvents('places', 'click', 'show 3');
        }
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'point4',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        openPopup: function openPopup() {
            this.$store.commit('SET_POPUP', 'popup4');
            this.gaEvents('places', 'click', 'show 4');
        }
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'point5',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        openPopup: function openPopup() {
            this.$store.commit('SET_POPUP', 'popup5');
            this.gaEvents('places', 'click', 'show 5');
        }
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup1',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default.a]
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup2',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default.a]
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup3',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default.a]
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup4',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default.a]
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popup5',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__components_pages_popups_popup_mix_vue___default.a]
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'popupMix',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        closePopup: function closePopup() {
            this.$store.commit('SET_POPUP', '');
            this.gaEvents('places', 'click', 'close');
        },
        afterEnter: function afterEnter() {
            this.$refs['popup'].classList.add('show');
        }
    },
    watch: {
        '$route': function $route() {
            this.$store.commit('SET_POPUP', '');
            this.gaEvents('places', 'click', 'close');
            next();
        }
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'competition',
    data: function data() {
        return {
            nextFlag: true
        };
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Form__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'first',
    components: {
        Form: __WEBPACK_IMPORTED_MODULE_1__components_common_Form___default.a
    },
    data: function data() {
        return {
            showForm: true
        };
    },

    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        close: function close() {
            this.showForm = false;
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Form__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'last',
    components: {
        Form: __WEBPACK_IMPORTED_MODULE_1__components_common_Form___default.a
    },
    data: function data() {
        return {
            showForm: false
        };
    },


    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        },
        show: function show() {
            this.showForm = true;
            this.gaEvents('product', 'click', 'get code');
        },
        close: function close() {
            this.showForm = false;
            this.gaEvents('product', 'click', 'close popup');
        }
    }

});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pageMain',
    methods: {
        gaEvents: function gaEvents(ctegory, event, label) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send(ctegory, event, label);
        }
    }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_path_ap_svg__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_path_ap_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_path_ap_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathMover_PathMover__ = __webpack_require__(129);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'path2',
    data: function data() {
        return {
            pathMover: null
        };
    },

    components: {
        pathSvg: __WEBPACK_IMPORTED_MODULE_1__assets_svg_path_ap_svg___default.a
    },
    methods: {
        createPathMover: function createPathMover() {
            var SVG = this.$refs['svgPath'].$el;
            //this.pathMover = new PathMover(SVG);
        }
    },
    mounted: function mounted() {
        this.createPathMover();
    }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'route-item',
    data: function data() {
        return {
            toOtherPage: false
        };
    },

    props: {
        to: {
            type: [String],
            required: false,
            default: '/'
        },
        element: {
            type: [String],
            required: false,
            default: 'index'
        }
    },
    computed: {
        isActive: function isActive() {
            return this.$route.path === this.to;
        }
    },
    methods: {
        onDone: function onDone() {},
        checkEl: function checkEl() {
            if (document.getElementById('#' + this.element) !== null) {} else {
                this.$router.push(this.to);
            }
        }
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(12);
//
//
//
//
//
//




var URLS = {
    "vk": "https://vk.com/share.php?url=",
    "fb": "https://www.facebook.com/sharer/sharer.php?u=",
    "tw": "https://twitter.com/intent/tweet?text=&hashtags=&url=",
    "ok": "https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.shareUrl=",
    "tg": "https://telegram.me/share/url?url="
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'shareLink',
    props: {
        network: {
            type: [String],
            required: true
        },
        article: {
            type: [String],
            required: false
        },
        url: {
            type: [String],
            required: true
        },
        title: {
            type: [String],
            required: false,
            default: ''
        },
        description: {
            type: [String],
            required: false,
            default: ''
        },
        image: {
            type: [String],
            required: false,
            default: ''
        }
    },
    components: {},
    methods: {
        sharePopup: function sharePopup(url, width, height) {
            if (!width) width = 400;
            if (!height) height = 400;

            var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');
            var watch_timer = setInterval(function () {
                if (share_window.closed) {
                    clearInterval(watch_timer);
                    this.$emit('onShareClose');
                    return;
                }
            }, 200);
        },
        onShareStart: function onShareStart() {
            this.sharePopup(URLS[this.network] + encodeURIComponent(this.url + '?image=' + encodeURIComponent(this.image) + '&title=' + encodeURIComponent(this.title) + '&description=' + encodeURIComponent(this.description) + '&article=' + encodeURIComponent(this.article)), 550, 300);
        }
    }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var self = null;

var CalculateBackwardDirectionBehavior = function () {
    function CalculateBackwardDirectionBehavior(parentContext) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CalculateBackwardDirectionBehavior);

        self = parentContext;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CalculateBackwardDirectionBehavior, [{
        key: "calculateBakwardDirection",
        value: function calculateBakwardDirection(position, angle) {
            return position < self._prevPercent ? angle - 180 : angle;
        }
    }]);

    return CalculateBackwardDirectionBehavior;
}();

/* harmony default export */ __webpack_exports__["a"] = (CalculateBackwardDirectionBehavior);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var self = null;

var DontCalculateBackwardDirectionBehavior = function () {
    function DontCalculateBackwardDirectionBehavior(parentContext) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DontCalculateBackwardDirectionBehavior);

        self = parentContext;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DontCalculateBackwardDirectionBehavior, [{
        key: "calculateBakwardDirection",
        value: function calculateBakwardDirection(position, angle) {
            return angle;
        }
    }]);

    return DontCalculateBackwardDirectionBehavior;
}();

/* harmony default export */ __webpack_exports__["a"] = (DontCalculateBackwardDirectionBehavior);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var self = null; // Parent class scope context

var UpdatePathByConstantValueBehavior = function () {
    function UpdatePathByConstantValueBehavior(parentContext) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UpdatePathByConstantValueBehavior);

        self = parentContext;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UpdatePathByConstantValueBehavior, [{
        key: "updatePath",
        value: function updatePath(value) {
            self._currentLen += value;
        }
    }]);

    return UpdatePathByConstantValueBehavior;
}();

/* harmony default export */ __webpack_exports__["a"] = (UpdatePathByConstantValueBehavior);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var self = null; // Parent class scope context

var UpdatePathByPercentageBehavior = function () {
    function UpdatePathByPercentageBehavior(parentContext) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UpdatePathByPercentageBehavior);

        self = parentContext;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UpdatePathByPercentageBehavior, [{
        key: "updatePath",
        value: function updatePath(value) {
            self._currentLen = this._getPositionByPercent(value, self._totalPathLen);
        }
    }, {
        key: "_getPositionByPercent",
        value: function _getPositionByPercent(percent, len) {
            var position = percent * len;
            return position;
        }
    }]);

    return UpdatePathByPercentageBehavior;
}();

/* harmony default export */ __webpack_exports__["a"] = (UpdatePathByPercentageBehavior);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UpdatePathBehavior_UpdatePathByPercentageBehavior__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpdatePathBehavior_UpdatePathByConstantValueBehavior__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BackwardDirectionBehavior_CalculateBackwardDirectionBehavior__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackwardDirectionBehavior_DontCalculateBackwardDirectionBehavior__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UpdatePathBehavior_UpdatePathByPercentageBehavior__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__UpdatePathBehavior_UpdatePathByConstantValueBehavior__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__BackwardDirectionBehavior_CalculateBackwardDirectionBehavior__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__BackwardDirectionBehavior_DontCalculateBackwardDirectionBehavior__["a"]; });








/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BackwardDirectionBehaviorType = {
    Calculate: "Calculate",
    DontCalculate: "DontCalculate"
};

/* harmony default export */ __webpack_exports__["a"] = (BackwardDirectionBehaviorType);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var UpdatePathBehaviorType = {
    ByPercentage: "ByPercentage",
    ByConstantValue: "ByConstantValue"
};

/* harmony default export */ __webpack_exports__["a"] = (UpdatePathBehaviorType);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PathMover__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Types__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PathMover__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Types__; });





/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouterItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_routeItem__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_routeItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_routeItem__);


var RouterItem = {
    install: function install(Vue, options) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_ui_routeItem___default.a.name, __WEBPACK_IMPORTED_MODULE_0__components_ui_routeItem___default.a);
    }
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_articles_article1__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_articles_article1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_articles_article1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_articles_article2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_articles_article2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_articles_article2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_articles_article3__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_articles_article3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_articles_article3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__ = __webpack_require__(12);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [{
        path: '/',
        name: 'index',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/');
            next();
        }
    }, {
        path: '/main',
        name: 'main',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/main');
            next();
        }
    }, {
        path: '/point1',
        name: 'point1',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/point1');
            next();
        }
    }, {
        path: '/point2',
        name: 'point2',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/point2');
            next();
        }
    }, {
        path: '/point3',
        name: 'point3',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/point3');
            next();
        }
    }, {
        path: '/point4',
        name: 'point4',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/point4');
            next();
        }
    }, {
        path: '/point5',
        name: 'point5',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/point5');
            next();
        }
    }, {
        path: '/picnic',
        name: 'picnic',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/picnic');
            next();
        }
    }, {
        path: '/article1',
        name: 'article1',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_articles_article1___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/article1');
            next();
        }
    }, {
        path: '/article2',
        name: 'article2',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_articles_article2___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/article2');
            next();
        }
    }, {
        path: '/article3',
        name: 'article3',
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_articles_article3___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_6__tools_Helpers__["a" /* default */].ga().send('send', 'pageview', '/article3');
            next();
        }
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_SOCIAL_URL", function() { return GET_SOCIAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCIAL_LOGIN", function() { return SOCIAL_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USER", function() { return GET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEND_FORM", function() { return SEND_FORM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(66);


var BASE_URL = '/api/emails/create';
var URL_ROOT = '/api';

var GET_SOCIAL_URL = function GET_SOCIAL_URL(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/auth/social-url').then(function (response) {
            resolve();
        }, function () {
            reject();
        });
    });
};

var LOGOUT = function LOGOUT(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/auth/logout').then(function () {
            resolve();
        }, function () {
            reject();
        });
    });
};

var SOCIAL_LOGIN = function SOCIAL_LOGIN(_ref3, sn) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var url = state.url[sn];

    var screenX = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft;
    var screenY = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop;
    var outerWidth = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.body.clientWidth;
    var outerHeight = typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.body.clientHeight - 22;
    var width = 800;
    var height = 600;
    var left = parseInt(screenX + (outerWidth - width) / 2, 10);
    var top = parseInt(screenY + (outerHeight - height) / 2.5, 10);
    var features = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var win = window.open(url, "_blank", features);

        var watch_timer = setInterval(function () {
            try {
                if (win.closed) {
                    clearInterval(watch_timer);
                    GET_USER().then(function (response) {
                        resolve();
                    }, function () {
                        reject();
                    });
                }
            } catch (e) {
                reject();
            }
        }, 200);
    });
};

var GET_USER = function GET_USER(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/user').then(function (response) {
            resolve();
        }, function () {
            reject();
        });
    });
};

var SEND_FORM = function SEND_FORM(_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(BASE_URL, data).then(function (response) {
            resolve();
        }, function (error) {
            reject();
        });
    });
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CURRENT_ID", function() { return GET_CURRENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_POPUP", function() { return GET_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FORM", function() { return SET_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_SCROLL_PERCENTAGE", function() { return GET_SCROLL_PERCENTAGE; });

var GET_CURRENT_ID = function GET_CURRENT_ID(state) {
  return state.currentId;
};

var GET_POPUP = function GET_POPUP(state) {
  return state.popup;
};

var SET_FORM = function SET_FORM(state) {
  return state.isActive;
};

var GET_SCROLL_PERCENTAGE = function GET_SCROLL_PERCENTAGE(state) {
  return state.scrollPercentage;
};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(556);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.credentials = true;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    actions: __WEBPACK_IMPORTED_MODULE_5__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ID", function() { return UPDATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_POPUP", function() { return SET_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FORM", function() { return SET_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCROLL_PERCENTAGE", function() { return SET_SCROLL_PERCENTAGE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(131);


var UPDATE_ID = function UPDATE_ID(State, id) {
    State.currentId = parseInt(id);
};

var SET_POPUP = function SET_POPUP(State, data) {
    State.popup = data;
};

var SET_FORM = function SET_FORM(State, isActive) {
    State.isActive = isActive;
};

var SET_SCROLL_PERCENTAGE = function SET_SCROLL_PERCENTAGE(State, scrollPercentage) {
    State.scrollPercentage = scrollPercentage;
};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialShare__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__socialShare__);


var ShareLink = {
    install: function install(Vue, option) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__socialShare___default.a.name, __WEBPACK_IMPORTED_MODULE_0__socialShare___default.a);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ShareLink);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dictionary; });

var dictionary = {
    ru: {
        custom: {}
    },
    en: {
        custom: {}
    }
};

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(554),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(553),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(551),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(548),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollMain",
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "article-block article-block1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Солнечная бодрость Сицилии\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Сицилия — яркий и солнечный остров, омываемый тремя морями.\n                            Смотрите видео о том, как природа этого острова зовет к приключениям!\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 1')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "article-block article-block2"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Лимонные ароматы Палермо\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 2')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "article-block article-block3"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "quotes-img2 animate-img"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Природная гармония в Швебиш-Гмюнде\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 3')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    В каждое путешествие я собираюсь с чувством, что меня ждет что-то новое и интересное. Вот и на этот раз поездка получилась насыщенной и познавательной\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left animate-block"
  }, [_c('div', {
    staticClass: "img img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article1/front-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article1/back-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img3 delay6"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes-img animate-img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/img1.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Почти все свое детство я провела в Крыму у бабушки. Часто я помогала ей собирать фрукты для компота.\n                    Но вот собирать лимоны на Сицилии для создания органической косметики — это очень приятный и новый опыт\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right animate-block"
  }, [_c('div', {
    staticClass: "img img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/front-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/back-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img3 delay6 animate-img"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes-img animate-img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/img1.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Швебиш-Гмюнд — очень милый небольшой городок с пряничными домиками, в пригороде которого есть сказочный сад\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left animate-block"
  }, [_c('div', {
    staticClass: "img img1 "
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/front-gr.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/back-gr.jpg",
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fSize + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competition"
  }, [_c('div', {
    staticClass: "competition-block"
  }, [_c('p', [_vm._v("Выиграйте путешествие на двоих в сад Weleda в Германии!")]), _vm._v(" "), _c('route-item', {
    staticClass: "next",
    attrs: {
      "to": '/picnic',
      "element": 'picnic'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go down')
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#' + _vm.element,
        container: '#scrollBar',
        duration: 800,
        onDone: _vm.onDone
      }),
      expression: "{\n    el: '#'+element,\n    container: '#scrollBar',\n    duration: 800,\n    onDone: onDone\n    }"
    }],
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": _vm.to
    },
    on: {
      "click": function($event) {
        _vm.checkEl()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    ref: "pageIndex",
    staticClass: "page-index"
  }, [_c('pathAirPlane', {
    ref: "svgPathEl"
  }), _vm._v(" "), _c('first', {
    staticClass: "page",
    attrs: {
      "id": "index"
    }
  }), _vm._v(" "), _c('pageMain', {
    ref: "mainPage",
    staticClass: "page",
    attrs: {
      "id": "main"
    }
  }), _vm._v(" "), _c('point1', {
    staticClass: "page",
    attrs: {
      "id": "point1"
    }
  }), _vm._v(" "), _c('point2', {
    staticClass: "page",
    attrs: {
      "id": "point2"
    }
  }), _vm._v(" "), _c('point3', {
    staticClass: "page",
    attrs: {
      "id": "point3"
    }
  }), _vm._v(" "), _c('point4', {
    staticClass: "page",
    attrs: {
      "id": "point4"
    }
  }), _vm._v(" "), _c('point5', {
    staticClass: "page",
    attrs: {
      "id": "point5"
    }
  }), _vm._v(" "), _c('competition', {
    attrs: {
      "id": "competition"
    }
  }), _vm._v(" "), _c('last', {
    staticClass: "page",
    attrs: {
      "id": "picnic"
    }
  })], 1)]), _vm._v(" "), _c(_vm.popup, {
    tag: "component"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "last"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Weleda на Пикнике «Афиши»!\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    4 августа в парке «Коломенское» прошел грандиозный Пикник «Афиши», на котором специально для вас мы создали отдельный уголок природы.\n                    Здесь можно было почувствовать аромат лимонов, ощутить магию летнего сада и поближе познакомиться с натуральной косметикой.\n                    Вновь насладиться моментом можно в нашем "), _c('a', {
    staticClass: "line",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/weledarussia"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'instagram')
      }
    }
  }, [_vm._v("Instagram")]), _vm._v(" по тегу "), _c('strong', [_vm._v("#WeledaPicnic")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-promo",
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n                    Получить скидку на косметику\n                ")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('Form', {
    attrs: {
      "showForm": _vm.showForm,
      "showCloseMobile": true
    },
    on: {
      "closeForm": _vm.close
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Москва, Коломенское\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "desc"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "/static/pdf/rules.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Правила участия")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа")])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onShareStart($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pathScreen"
  }, [_c('div', {
    staticClass: "path"
  }, [_c('pathSvg', {
    ref: "svgPath"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Аликанте — город светлого сияния\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                   Натуральная косметика Weleda сотрудничает с кооперативом, который управляет 6000 га органических...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point1/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point1/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Мне нравится местный климат, природа и культура. Обожаю испанские маленькие прибрежные города\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Аликанте, Испания\n                    ")])])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Сегодня Базель не сходит с газетных полос: в городе, расположенном между...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point2/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img2"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point2/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Все мои поездки в эту страну были связаны со сноубордингом, тренировками в горах и наслаждением природой\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Базель, Швейцария\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Базель — историческая "), _c('br'), _vm._v("\n                    родина Weleda\n                ")])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Weleda была одной из первых косметических марок, которая взялась выращивать ботаническое сырье...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point3/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point3/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    В пригороде Швебиш-Гмюнда есть сказочный сад. Тот самый, где вот уже почти 100 лет создают истинно натуральную косметику\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Швeбиш-Гмюнд, Германия\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Сказочный сад "), _c('br'), _vm._v(" в Швeбиш-Гмюнд\n                ")])
}]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Солнечная Сицилия\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Сицилийские цитрусовые занимают важное место на рынке европейских...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img4"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Солнечная Сицилия — очень красивый и разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с природой\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Сицилия, Италия\n                    ")])])
}]}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Карпатские горы\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Румынские Карпаты, где Weleda выращивает арнику для своего знаменитого массажного масла, — это регион богатой культуры...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point5/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img5"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point5/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Я не была в Румынии, но увидеть своими глазами величие Карпатских гор и ощутить силу природы - моя мечта.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Карпатские горы, Румыния\n                    ")])])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', [_c('div', {
    staticClass: "center"
  }, [_c('ul', _vm._l((_vm.menu), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('route-item', {
      staticClass: "menu__link",
      attrs: {
        "to": item.route,
        "element": item.element
      },
      nativeOn: {
        "click": function($event) {
          _vm.toogleMenu(item.route)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    staticClass: "form collapsed",
    class: {
      deployed: _vm.active
    }
  }, [(!_vm.$root.isMobile || _vm.showCloseMobile) ? _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }) : _c('a', {
    staticClass: "open",
    class: {
      close: _vm.active
    },
    on: {
      "click": _vm.sub
    }
  }), _vm._v(" "), _c('form', {
    class: {
      hidden_form: _vm.shows
    },
    attrs: {
      "action": "",
      "method": "POST",
      "novalidate": "true"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.check($event)
      }
    }
  }, [_c('span', {
    staticClass: "desc",
    on: {
      "click": _vm.sub
    }
  }, [_vm._v("\n                    Оставьте свой e-mail и получите скидку 15% на первый заказ в интернет-магазине "), _c('a', {
    attrs: {
      "href": "https://www.weleda.ru/",
      "target": "_blank"
    }
  }, [_vm._v("www.weleda.ru")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Ваш e-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors.length) ? _c('p', _vm._l((_vm.formErrors), function(error) {
    return _c('span', {
      staticClass: "err"
    }, [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Получить")])]), _vm._v(" "), _c('p', {
    staticClass: "inform"
  }, [_c('a', {
    attrs: {
      "href": "/static/pdf/Personal-information.pdf",
      "download": "Personal information"
    }
  }, [_vm._v("Условия и способы обработки и хранения персональных данных")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shows),
      expression: "shows"
    }],
    staticClass: "code"
  }, [_c('p', [_vm._v("Ваш промокод: LEMON")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.weleda.ru/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('product', 'click', 'linkpopup')
      }
    }
  }, [_vm._v("www.weleda.ru")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "first",
    staticClass: "first"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/video/Weleda.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/static/video/Weleda.ogg",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask-video"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pare-el"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "center animation3"
  }, [_c('route-item', {
    staticClass: "next",
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go down')
      }
    }
  })], 1)]), _vm._v(" "), _c('Form', {
    attrs: {
      "showForm": _vm.showForm
    },
    on: {
      "closeForm": _vm.close
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center animation1"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                МОЁ ДРУГОЕ ЛЕТО\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center animation2"
  }, [_c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                Профессиональная сноубордистка и путешественница Оля Смешливая вместе с натуральной косметикой Weleda приглашают в удивительное приключение по красивейшим местам Европы.\n                Узнайте, как получить новый опыт, зарядиться энергией природы и насладиться свежим горным воздухом.\n            ")])])
}]}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    ref: "resize",
    staticClass: "app-layout",
    class: {
      mobile: _vm.$root.isMobile, 'open-popup': _vm.popup != '' || _vm.$route.path == '/picnic'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header",
    class: {
      'hide': _vm.openMenu
    }
  }, [_c('a', {
    staticClass: "logo-a",
    attrs: {
      "href": "https://www.afisha.ru/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'logo afisha')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logo-b",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'main')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.weleda.ru/?utm_source=afisha&utm_medium=logo&utm_term=range&utm_content=main_page&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'logo weleda')
      }
    }
  }, [_c('Logo')], 1)]), _vm._v(" "), _c('a', {
    staticClass: "open-menu",
    class: {
      'open': _vm.openMenu
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "prevet", undefined, $event.key, undefined)) { return null; }
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('menu-app', {
    staticClass: "menu",
    on: {
      "closeMenu": _vm.toggleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    on: {
      "click": _vm.closeShare
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    ref: "page"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "social-block"
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('opensocial')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point5/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Я не была в Румынии, но увидеть своими глазами величие Карпатских гор и ощутить силу природы - моя мечта.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Карпатские горы, Румыния\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Карпатские горы\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Румынские Карпаты, где Weleda выращивает арнику для своего знаменитого массажного масла, — это регион богатой культуры, в том числе фермерской: большинство местных жителей, занятых в проекте Weleda (более 480 человек ), происходят из семей, в которых навыки собирательства и культивирования передаются по наследству. Урожай арники собирают летом — по особой методике, разработанной вместе со Всемирным фондом дикой природы: с каждого растения снимают ограниченное количество желтых цветков, чтобы популяция дикорастущей арники сохранялась и росла. За восемь лет площадь земель с цветущей арникой серьезно увеличилась — Карпаты становятся по-настоящему «золотыми».\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Массажное масло "), _c('br'), _vm._v(" с арникой\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        100% натуральное масло с арникой, созданное в 1923 году, пользуется доверием среди профессиональных спортсменов и физиотерапевтов. Оно отлично подходит ценителям активного образа жизни.\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%B0?utm_source=afisha&utm_medium=card&utm_content=arnica&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point5/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point4/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Солнечная Сицилия — очень красивый и разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с природой\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Сицилия, Италия\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Солнечная Сицилия\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Сицилийские цитрусовые занимают важное место на рынке европейских фруктов: уже 150 лет назад лимонные плантации на острове были самым прибыльным сельскохозяйственным угодьем в Европе, превосходя даже знаменитые фруктовые сады в окрестностях Парижа. Сицилийские лимоны начали культивировать в XVIII веке, и они настолько душисты и сочны, что за их эфирное масло борются ведущие парфюмерные дома. А у Weleda на Сицилии есть сады, в которых биодинамическим способом выращивают органические лимоны. Местные лимоны дарят средствам марки заряд витамина C и яркий запах Средиземноморья.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Лимон\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Эфирное масло и сок лимона — одни из самых важных компонентов косметических средств. Бодрящие ароматы лимона помогают наполнить день позитивом и энергией.\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%B2%D0%B5%D0%B4%D1%83%D1%89%D0%B8%D0%B5-%D1%80%D0%B0%D1%81%D1%82%D0%B5%D0%BD%D0%B8%D1%8F/%D0%BB%D0%B8%D0%BC%D0%BE%D0%BD?utm_source=afisha&utm_medium=card&utm_content=lemon&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point3/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    В пригороде Швебиш-Гмюнда есть сказочный сад. Тот самый, где вот уже почти 100 лет создают истинно натуральную косметику\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Швeбиш-Гмюнд, Германия\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Сказочный сад "), _c('br'), _vm._v(" в Швeбиш-Гмюнд\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Weleda была одной из первых косметических марок, которая взялась выращивать ботаническое сырье в собственных садах. Сегодня их у компании восемь, и самый большой находится в городке Швебиш-Гмюнд, что в 50 километрах от Штутгарта. Как и другие, этот сад биодинамический: в нем не используются инсектициды и искусственные удобрения, хозяйство ведется в соответствии с ритмами природы (например, фазами Луны), а газонокосильщиками «работают» овцы и утки, свободно разгуливающие по саду. А неподалеку от сада специалисты Weleda применяют уникальные знания и технологии на практике, ведь именно здесь находится производство косметики.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Универсальный питательный крем SKINFOOD\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Крем с насыщенной текстурой и 100% натуральными ингредиентами.\n                            Один из первых продуктов Weleda, который до сих пор на пике популярности и востребован среди звезд и моделей в Англии и США.\n\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda/%D1%84%D0%B8%D0%BB%D0%BE%D1%81%D0%BE%D1%84%D0%B8%D1%8F-%D1%83%D1%85%D0%BE%D0%B4%D0%B0/%D0%BA%D0%B0%D0%BA-%D0%BF%D0%B8%D1%82%D0%B0%D0%B5%D1%82%D1%81%D1%8F-%D0%B2%D0%B0%D1%88%D0%B0-%D0%BA%D0%BE%D0%B6%D0%B0?utm_source=afisha&utm_medium=card&utm_term=germany&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img img-popup3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point3/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point2/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Все мои поездки в эту страну были связаны со сноубордингом, тренировками в горах и наслаждением природой\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Базель, Швейцария\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Базель — историческая "), _c('br'), _vm._v("\n                        родина Weleda\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                       Сегодня Базель не сходит с газетных полос: в городе, расположенном между изумрудными вершинами Юры и Шварцвальда, три дюжины музеев, первоклассный музыкальный театр, сияющие штаб-квартиры крупнейших банков. Но чуть меньше ста лет назад Базель давал газетам совсем другие инфоповоды: в начале 1920-х в базельском пригороде Арлесхайм открылась первая в мире клиника антропософской медицины, основанная тремя энтузиастами — врачом, философом и фармацевтом. Главный принцип антропософской медицины — правильно стимулировать организм, чтобы тот сам боролся с болезнью, — близок взглядам Weleda, компании, которая выросла из маленькой лаборатории при арлесхаймской клинике.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Натуральные ингредиенты\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Для сохранения природной силы около 1000 натуральных ингредиентов сотрудники Weleda собирают растения быстро и минимально обрабатывают их: только таким образом вещества и активные компоненты раскрывают и сохраняют свои ценные качества.\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda?utm_source=afisha&utm_medium=card&utm_term=switzerland&utm_content=natural_cosmetics&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img popup-products-img2 "
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point2/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point1/popup/bg.jpg')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                   Мне нравится местный климат, природа и культура. Обожаю испанские маленькие прибрежные города\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Аликанте, Испания\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Аликанте — город "), _c('br'), _vm._v("светлого сияния\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Натуральная косметика Weleda сотрудничает с кооперативом, который управляет 6000 га органических миндальных рощ под Аликанте. Сборщики миндаля здесь отказались от интенсивного полива деревьев, так как искусственное орошение приводит к эрозии и засолению почвы.\n                        У этого решения, как у большинства экологических инициатив, есть цена: с одного гектара такой земли фермер получает всего 500 кг миндаля, что в десять раз меньше, чем, например, в Калифорнии, где практикуют «агрессивный» полив.\n                        Разницу в фермерском заработке компенсирует Weleda, для которой производство высококачественного органического миндального масла давно перестало быть всего лишь бизнесом.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Миндаль\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Миндальное масло считается одним из самых ценных, применяемых в косметологии. Оно успокаивает раздраженную кожу, окутывает ее невесомым защитным слоем и увлажняет кожу.                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%BC%D0%B8%D0%BD%D0%B4%D0%B0%D0%BB%D1%8C?utm_source=afisha&utm_medium=card&utm_content=almond&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img popup-products-img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point1/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article3"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'TZBmTiKCZ9U',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide7.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide8.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Гармония и гладкость кожи\n                        ")]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела\n                        ")]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product7.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Деликатное "), _c('br'), _vm._v(" питательное "), _c('br'), _vm._v(" масло для лица\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Гармония и гладкость кожи\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product8.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Деликатный "), _c('br'), _vm._v(" увлажняющий крем\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Лёгкий увлажняющий крем "), _c('br'), _vm._v(" для ухода за чувствительной кожей\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product9.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Универсальный "), _c('br'), _vm._v("питательный крем "), _c('br'), _vm._v("SKIN FOOD\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _vm._m(17)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Природная гармония "), _c('br'), _vm._v(" в Швебиш-Гмюнде\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Швебиш-Гмюнд — очень милый небольшой городок с пряничными домиками, в пригороде которого есть сказочный сад. Тот самый, где вот уже почти сто лет создают истинно натуральную косметику")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Небольшой старинный городок в пятидесяти километрах от Штутгарта редко попадает в новости — разве что местный фермер получит приз за самую симпатичную овцу в земле Баден-Вюртемберг.                         ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Швебиш-Гмюнд — образец покоя и стабильности: жизнь здесь течет размеренно, в соответствии с сезонами и естественными ритмами природы.                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                        В этом смысле биодинамический сад Weleda на севере города можно считать совершенно «швебиш-гмюндским» предприятием — жизнь его абсолютно подчинена природной логике.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Из всех европейских садов компании тот, что в Германии, — самый большой и биологически разнообразный: 23 га земли и 1000 видов растений, в том числе 140 лекарственных — последние выращивают для производства медицинских препаратов и натуральных косметических продуктов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Так, большую часть календулы, которые Weleda использует в своих средствах, собирают и перерабатывают, превращая в спиртовую вытяжку и масляный экстракт, именно здесь.\n                        Помимо узнаваемых оранжевых цветов, на открытых полях растет множество однолетних и многолетних культур — терн, гамамелис, эхинацея, боярышник, дудник, чистотел и многие другие.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        В этом саду царит атмосфера любви, счастья и умиротворения, что передается через растения косметике. Все растения в этом саду целебные, даже листья березы\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Для обработки почвы фермеры и садоводы используют только те компоненты, которые образовались естественным путем, а значит, несут в себе энергию природы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        У любого растения и животного в саду Weleda есть своя продуманная ниша: горец, например, служит своеобразным зонтиком для папоротника, который любит тень и прохладу.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Этот сад лекарственных растений — крупнейший биодинамический сад в Европе. При производстве используется лишь натуральное сырье и неизменная рецептура\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article2/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Здесь же у компании самое крупное производство — некоторые травы и цветы, попадая в продукты марки, не всегда успевают осознать разлуку с землей, настолько свежее у компании сырье, и только подобным образом полезные вещества и компоненты растений могут сохранить свои ценные качества. Все растения собираются максимально быстро и вручную, при этом запрещено использование электрического тока и воздействие электромагнитного излучения.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Словом, к выращиванию растений, их сбору и финальному этапу производства здесь относятся максимально бережно, ведь именно это лежит в основе принципов Weleda — сохраняя природу, создавать натуральную косметику, наполненную силой и энергией тысячи растений.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product7.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Деликатное "), _c('br'), _vm._v(" питательное "), _c('br'), _vm._v(" масло для лица\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product8.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Деликатный "), _c('br'), _vm._v(" увлажняющий крем\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Лёгкий увлажняющий крем "), _c('br'), _vm._v(" для ухода за чувствительной кожей\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product9.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                    Универсальный "), _c('br'), _vm._v("питательный крем "), _c('br'), _vm._v("SKIN FOOD\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,Скин фуд")])])])
}]}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article2"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Лимонные ароматы Палермо\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'uT3tKFkRwK4',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide7.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Коктейль бодрости и свежесть 24 часа\n                        ")]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Коктейль бодрости и свежесть 24 часа\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product5.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" масло для тела\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Легкое масло с бодрящим ароматом "), _c('br'), _vm._v(" для энергии и тонуса\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product6.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" молочко для тела\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Легкое молочко для тела "), _c('br'), _vm._v(" с сочным ароматом цитрусов\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_vm._m(17), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 3')
      }
    }
  }, [_vm._v("\n                    Далее\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Почти все свое детство я провела в Крыму у бабушки. Часто я помогала ей собирать фрукты для компота.\n                        Но вот собирать лимоны на Сицилии для создания органической косметики — это очень приятный и новый опыт\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Весь 2018 год Палермо проведет в статусе культурной столицы Италии: эту должность «Орлиный» (так называют административный центр Сицилии итальянцы) вырвал у нескольких древних городов-претендентов прошедшей весной.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Действительно, Палермо очень красив: эффектная мешанина готики, барокко и арабской архитектуры, парки со старыми лаврами и инжиром, залитые солнцем набережные Тирренского моря — путеводители советуют заложить на осмотр города не менее пяти дней.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Но на деле Палермо всегда был столицей, пусть и очень специальной — итальянских лимонов и всевозможных лимонных удовольствий.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Золотые фрукты на Сицилии начали культивировать в XVIII веке.\n                        Сначала лимонами занимались монахи иезуитского ордена, потом подхватили остальные: плантации оказались прибыльным бизнесом.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        На плодородных почвах вокруг Палермо лимон прижился прекрасно: несмотря на то что город отделяет от Этны около четырех часов езды на машине, богатый минералами вулканический пепел долетает сюда легко, в результате многие лимоны под Палермо доживают до ста лет и дают до тонны плодов с дерева в год. Фрукты здесь особые: их отличает значительная кислотность в сочетании с высоким содержанием сахаристых веществ.\n                        Отчасти дело в климате и составе почв, во многом — в биодинамических техниках земледелия, которые используются местными лимонными хозяйствами.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Те, что заняты в партнерском проекте Weleda, имеют престижный сертификат Demeter, подтверждающий их биодинамический статус: последний означает, что фермерское предприятие прошло трехлетний аудит удобрений, воды и способов возделывания и сбора урожая на подотчетном ему участке.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Для меня стало новостью, что урожай лимонов собирают 3 раза в год и созревший лимон не обязательно должен быть желтым, в зависимости от сезона он может оставаться и зеленым")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article3/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Биодинамическое земледелие придумал Рудольф Штайнер, один из основателей клиники антропософской медицины в швейцарском Арлесхайме, откуда выросла компания Weleda.\n                            Штайнер верил, что в сельское хозяйство, как и в здоровье человека, нельзя вмешиваться агрессивно — и то и другое нужно синхронизировать с естественными биоритмами природы, привлекая энергии воды, света, земли и воздуха. В лимонных садах Weleda фрукты собирают и сортируют исключительно вручную (к слову, лимонные деревья под Палермо плодоносят круглый год).\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            И в итоге столь бережного отношения местные лимоны — образцовые, сочные, ароматные, и в каждом словно заключен небольшой луч островного солнца, что, конечно, передается косметическим продуктам, которые способны зарядить вас энергией и поднять настроение.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Во время прогулки по саду Weleda можно сразу посмотреть и на финальный результат сбора лимонов.\n                        Фермеры с гордостью показывают цитрусовую линейку косметики от Weleda и рассказывают о ней с огромным интересом\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Возможно, со стороны биодинамика может показаться сценарием знаменитого фантастического фильма, где недостающим для всеобщего счастья кусочком пазла оказалась искренняя любовь, в данном случае к природе и своему делу, но этот способ работает — дело Штайнера цветет, пахнет и плодоносит.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product4.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product5.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" масло для тела\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Легкое масло с бодрящим ароматом "), _c('br'), _vm._v(" для энергии и тонуса\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product6.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" молочко для тела\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Легкое молочко для тела "), _c('br'), _vm._v(" с сочным ароматом цитрусов\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                            Подробнее\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,Ролл-он")])])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article1"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Солнечная бодрость Сицилии",
      "image": "/static/img/share/share1.jpg",
      "description": "Сицилия — яркий и солнечный остров, омываемый тремя морями. Смотрите видео о том, как природа этого острова зовет к приключениям!",
      "article": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article1', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Солнечная бодрость Сицилии\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'CAc8NdDXbKs',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    ref: "slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide7.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide8.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article1/slides/slide9.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Гель смягчает кожу и сохраняет естественный баланс влаги\n                        ")]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Подготавливает мышцы к физическим нагрузкам, улучшает микроциркуляцию\n                        ")]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Естественная свежесть и защита от неприятного запаха 24 часа\n                        ")]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    ref: "products",
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v("освежающий гель"), _c('br'), _vm._v(" для душа\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Гель смягчает кожу и сохраняет естественный баланс влаги\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Массажное "), _c('br'), _vm._v("масло с арникой\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Подготавливает мышцы к физическим нагрузкам, улучшает микроциркуляцию\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Естественная свежесть и защита от неприятного запаха 24 часа\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_vm._m(17), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'go to longread 2')
      }
    }
  }, [_vm._v("\n                    Далее\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("В каждое путешествие я собираюсь с чувством, что меня ждет что-то новое и интересное. Вот и на этот раз поездка получилась насыщенной и познавательной")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Сицилия — яркий и солнечный остров, омываемый тремя морями. Здесь природа дает человеку все\n                        возможности для выращивания разнообразных фруктов, часть которых затем превращается в\n                        прекрасные косметические продукты.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Бирюзовое море и сизые макушки вулканов, древние руины и прекрасно сохранившиеся палаццо,\n                        терпкие лимоны — острову, вставшему на якорь у мыска итальянского сапога, есть что\n                        предложить любителям контрастов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Самая важная достопримечательность Сицилии, которую можно увидеть практически отовсюду, —\n                        Этна, высочайшая гора южной Италии и главный действующий вулкан Европы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Этна считается неопасной — настолько, что на ее склонах выращивают фрукты и разбивают\n                        виноградники, но сицилийцы с нежностью зовут ее la diva, «дивой», капризной оперной звездой,\n                        которая выступает тогда, когда этого меньше всего ждешь.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подъем на вершину вулкана Этна и открывающиеся оттуда пейзажи — это одно из самых сильных впечатлений от моего итальянского путешествия. Если вы планируете подняться на Этну, то советую взять с собой теплые вещи — на вершине лежит снег. Из косметики могу посоветовать Skin Food от Weleda, отличный питательный крем на все случаи, от обветривания и после солнца, питает, защищает и увлажняет\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Подняться к кратеру вулкана можно разными способами; большинство маршрутов пролегает по\n                        южному склону с его «марсианскими» пейзажами — серебристым песком, фумаролами и красивыми\n                        образованиями из зеленоватых кристаллов серы, которые вырастают в тех местах, где газ\n                        вырывается из трещин в земле.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Есть мнение, что воздух вулкана полезен для здоровья, — в это верят все сицилийцы, как\n                        прежде верили в то, что в кратере Этны есть вход в подземное царство Плутона.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Когда говорят, что Сицилия — вулканический остров, имеют в виду не только его геологические\n                        особенности: правда в том, что на протяжении нескольких тысяч лет в пламени Этны закалялись\n                        сицилийские пейзажи, кухня и даже культура.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Взять хотя бы знаменитое сицилийское барокко — уникальный архитектурный стиль, который\n                        отличают особая пышность и необычные формы, напоминающие языки пламени.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Его появлению предшествовало мощное извержение Этны и землетрясение 1693 года, позже\n                        названное Большим Сицилийским: мощные толчки сровняли юго-восток острова с землей, и многие\n                        города пришлось отстраивать заново — из вулканического камня.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Так и появились архитектурные шедевры, которыми теперь славится долина Валь-ди-Ното — ее\n                        соборы, церкви и палаццо особенно красивы с наступлением темноты, когда эффектно\n                        подсвечиваются прожекторами.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                       Солнечная Сицилия подарила мне редкую возможность полного слияния с природой. Очень красивый и разнообразный остров, омываемый тремя морями (Средиземным, Ионическим и Тирренским), непревзойденные пляжи, мысы, горы и, конечно, ароматные цитрусовые сады\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Сицилийскую кухню, в отличие от городков Валь-ди-Ното, пока не включили в Список всемирного\n                        наследия ЮНЕСКО, но она тоже совершенно «вулканическая» — cibo vulcanico, как ее называют\n                        местные шефы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Окружающие Этну почвы особенно богаты минеральными солями, и виноград, фрукты и овощи здесь\n                        рождаются с особенным соотношением сахара и кислоты.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Некоторые местные продукты даже имеют особенный знак качества, DOP — это и оливковое масло\n                        Monte Etna, и местная опунция, и зеленая фисташка.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        А сицилийские лимоны украшают большинство итальянских блюд: из них делают сорбеты, соусы к\n                        пасте и рыбным блюдам, их используют в качестве пряности и даже натурального консерванта —\n                        лимонный сок уплотняет нежную консистенцию рыбы и морепродуктов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Кроме того, эфирные масла в составе лимона превращают его в кладезь ценных косметических\n                        свойств, которые Weleda из года в год использует в своей продукции. Все цитрусовые, входящие\n                        в состав средств по уходу за телом, выращены в биодинамических хозяйствах — без пестицидов,\n                        гербицидов и других химикатов, зато в соответствии с естественными циклами биологической\n                        энергии.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        А еще на этом чудо-острове совершенно невероятный воздух, напоенный ароматами моря, лимонов\n                        и леса. Редкое, практически гастрономическое сочетание, ради которого на Сицилию приезжают\n                        миллионы людей каждый год.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                       На Сицилии я посетила знаменитые лимонные сады и узнала о сырье для производства цитрусовой линейки натуральной косметики Weleda. Кстати, сицилийские лимоны показались мне менее кислыми и более ароматными, чем те, к которым мы привыкли дома\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article1/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Но если хотите успеть насладиться сицилийской едой, природой и ароматом лимонов —\n                            поспешите: остров неумолимо движется по направлению к материковой Италии, собираясь\n                            подмять Липарские острова. Словом, у вас в запасе не более пары миллионов лет.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product1.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v("освежающий гель"), _c('br'), _vm._v(" для душа\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B8%D0%B9-%D0%B3%D0%B5%D0%BB%D1%8C-%D0%B4%D0%BB%D1%8F-%D0%B4%D1%83%D1%88%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_shower_gel&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product2.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Массажное "), _c('br'), _vm._v("масло с арникой\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%BC/%D0%BC%D0%B0%D1%81%D1%81%D0%B0%D0%B6%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D1%81-%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%BE%D0%B9?utm_source=afisha&utm_medium=longread&utm_content=arnica_massage_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product3.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82-24-%D1%87%D0%B0%D1%81%D0%B0-roll-on?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant_roll_on&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,ДОП,Монте этна,Ролл-он")])])
}]}

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

module.exports = {template: '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 291.84 114.14"><defs><clipPath id="a"><path fill="none" d="M0 0h291.84v114.14H0z"/></clipPath></defs><title>logo</title><g clip-path="url(#a)" fill="#575756"><path d="M85.15 95.52a5.62 5.62 0 0 1-.25 1.66 3.67 3.67 0 0 1-.9 1.49 4.5 4.5 0 0 1-1.74 1.06 8.28 8.28 0 0 1-2.81.4 19.34 19.34 0 0 1-2.14-.1q-.92-.1-1.68-.22a.61.61 0 0 1-.37-.14.47.47 0 0 1-.07-.28v-.92a.33.33 0 0 1 .11-.28.44.44 0 0 1 .28-.09h.07c.26 0 .56.05.89.07h2.89a6.34 6.34 0 0 0 1.76-.17 2.66 2.66 0 0 0 1.07-.55 2 2 0 0 0 .55-.86 3.63 3.63 0 0 0 .16-1.1 2.18 2.18 0 0 0-.14-.79 2.21 2.21 0 0 0-.46-.7 5.89 5.89 0 0 0-.85-.72q-.53-.38-1.31-.86L78 91.09a9.26 9.26 0 0 1-2.38-1.94 3.62 3.62 0 0 1-.79-2.36 3.49 3.49 0 0 1 1.43-3.08 7.11 7.11 0 0 1 4.07-1h1.07l1.1.06q.54 0 1 .09l.8.14a.39.39 0 0 1 .39.39v1a.34.34 0 0 1-.39.37l-1.85-.09h-2.1a5.43 5.43 0 0 0-2.59.46 1.82 1.82 0 0 0-.79 1.73 1.92 1.92 0 0 0 .6 1.4 10 10 0 0 0 1.91 1.38l2.12 1.27A15.55 15.55 0 0 1 83.22 92a7.06 7.06 0 0 1 1.13 1.1 3.55 3.55 0 0 1 .65 1.14 4.39 4.39 0 0 1 .18 1.29M91 83a.47.47 0 0 0-.46-.46h-1.16a.47.47 0 0 0-.46.46v1.84a.44.44 0 0 0 .14.32.44.44 0 0 0 .32.14h1.17a.45.45 0 0 0 .32-.14.44.44 0 0 0 .13-.33V83zm0 4.78a.47.47 0 0 0-.46-.46h-1.1a.44.44 0 0 0-.32.14.44.44 0 0 0-.14.32V99.5a.47.47 0 0 0 .46.46h1.1a.47.47 0 0 0 .46-.46V87.77zm13.8 12.05a.44.44 0 0 0 .14-.32v-7.57a5.71 5.71 0 0 0-1-3.54 3.6 3.6 0 0 0-3-1.24 6.12 6.12 0 0 0-1.86.26 10.43 10.43 0 0 0-1.79.79v-.44a.47.47 0 0 0-.13-.32.41.41 0 0 0-.31-.14H95.7a.4.4 0 0 0-.31.14.46.46 0 0 0-.13.32v11.74a.46.46 0 0 0 .13.32.4.4 0 0 0 .31.14h1.13a.48.48 0 0 0 .46-.46V89.8a12.17 12.17 0 0 1 1.59-.65 4.94 4.94 0 0 1 1.52-.25 3.78 3.78 0 0 1 1.13.15 1.71 1.71 0 0 1 .79.49 2.17 2.17 0 0 1 .46.93 6.06 6.06 0 0 1 .15 1.46v7.57a.48.48 0 0 0 .46.46h1.1a.44.44 0 0 0 .32-.14m12-.11a.55.55 0 0 0 .09-.35v-.82a.3.3 0 0 0-.11-.26.47.47 0 0 0-.28-.08h-.09q-.76.09-1.38.13t-1.47 0a2.56 2.56 0 0 1-2.14-.93 4.63 4.63 0 0 1-.74-2.89v-1.77a4.58 4.58 0 0 1 .75-2.88 2.57 2.57 0 0 1 2.13-.93h1.47c.41 0 .87.07 1.38.13h.09a.48.48 0 0 0 .28-.08.3.3 0 0 0 .11-.26v-.81a.55.55 0 0 0-.09-.36.66.66 0 0 0-.37-.15 13.28 13.28 0 0 0-1.32-.18c-.5 0-1-.07-1.55-.07a5.2 5.2 0 0 0-2.09.4 4.25 4.25 0 0 0-1.54 1.13 4.93 4.93 0 0 0-.94 1.76 7.72 7.72 0 0 0-.32 2.3v1.79a7.71 7.71 0 0 0 .32 2.3 4.81 4.81 0 0 0 1 1.76 4.35 4.35 0 0 0 1.54 1.13 5.08 5.08 0 0 0 2.08.4q.8 0 1.55-.07a12.74 12.74 0 0 0 1.32-.18.6.6 0 0 0 .37-.16M130 92.53a7.24 7.24 0 0 0-.32-2.22 4.63 4.63 0 0 0-1-1.7 4.19 4.19 0 0 0-1.58-1.08 5.89 5.89 0 0 0-2.21-.38 4.86 4.86 0 0 0-3.8 1.45 5.65 5.65 0 0 0-1.31 3.93v2.07a6.85 6.85 0 0 0 .45 2.67 4.56 4.56 0 0 0 1.18 1.73 4.25 4.25 0 0 0 1.67.9 7.13 7.13 0 0 0 1.93.26 20.23 20.23 0 0 0 2.15-.1q1-.1 2-.29a.55.55 0 0 0 .37-.17.6.6 0 0 0 .09-.36v-.82a.27.27 0 0 0-.11-.25.48.48 0 0 0-.25-.07h-.16c-.54.08-1.19.14-1.94.18s-1.48.07-2.15.07a3.14 3.14 0 0 1-2.39-.85 4.17 4.17 0 0 1-.81-2.9v-.32h7.7a.42.42 0 0 0 .44-.51v-1.24zm-2 .21h-6.1v-.21a4 4 0 0 1 .79-2.74 2.93 2.93 0 0 1 2.29-.87 2.89 2.89 0 0 1 2.26.83 4.13 4.13 0 0 1 .75 2.78v.21zM176.63 99.5a.49.49 0 0 1-.12.32.37.37 0 0 1-.3.14h-1.26a.37.37 0 0 1-.3-.14.49.49 0 0 1-.11-.32V84.74l-3.07.38h-.2a.21.21 0 0 1-.21-.25V83.7a.28.28 0 0 1 .25-.3l3.45-.48h1.43a.39.39 0 0 1 .44.44V99.5zM193 89.25a9.76 9.76 0 0 0-.39-2.92 5.36 5.36 0 0 0-1.12-2 4.52 4.52 0 0 0-1.76-1.18 6.55 6.55 0 0 0-2.32-.39 5.4 5.4 0 0 0-4.22 1.54 6.15 6.15 0 0 0-1.39 4.28v.14a5.21 5.21 0 0 0 .46 2.31 3.88 3.88 0 0 0 1.24 1.48 5 5 0 0 0 1.81.78 9.8 9.8 0 0 0 2.15.23 10.87 10.87 0 0 0 1.9-.15q.84-.15 1.58-.31v.25a17.1 17.1 0 0 1-.12 2.07 3.92 3.92 0 0 1-.53 1.61 2.81 2.81 0 0 1-1.2 1 4.9 4.9 0 0 1-2.12.38q-1.1 0-2.08-.09a16.36 16.36 0 0 1-1.85-.27h-.14a.43.43 0 0 0-.3.1.4.4 0 0 0-.12.31v.9a.32.32 0 0 0 .16.3 1.28 1.28 0 0 0 .39.14q.71.16 1.65.28a19.74 19.74 0 0 0 2.31.11 8.14 8.14 0 0 0 2.6-.38 4.43 4.43 0 0 0 1.89-1.21 5.31 5.31 0 0 0 1.14-2.13 11.32 11.32 0 0 0 .38-3.14v-4zm-2.09 2.19l-.74.15q-.41.08-.89.14l-1 .09h-.9a5.77 5.77 0 0 1-1.32-.15 3.24 3.24 0 0 1-1.14-.51 2.51 2.51 0 0 1-.81-1 3.51 3.51 0 0 1-.3-1.55v-.08a6.43 6.43 0 0 1 .25-2 3.27 3.27 0 0 1 .71-1.27 2.58 2.58 0 0 1 1.13-.69 4.92 4.92 0 0 1 1.47-.21 4.48 4.48 0 0 1 1.48.23 2.43 2.43 0 0 1 1.1.78 3.74 3.74 0 0 1 .68 1.48 10 10 0 0 1 .23 2.33zm16.3-4.6a3.63 3.63 0 0 0-1.35-3.13 7 7 0 0 0-4.15-1 20 20 0 0 0-2.13.12 13.11 13.11 0 0 0-2 .34.91.91 0 0 0-.31.14.32.32 0 0 0-.13.28v.81a.35.35 0 0 0 .37.41h.09c.64-.09 1.33-.17 2.07-.24s1.4-.1 2-.1a4.73 4.73 0 0 1 2.66.56 2.06 2.06 0 0 1 .79 1.81 3.43 3.43 0 0 1-.1.91 2.2 2.2 0 0 1-.37.74 4.08 4.08 0 0 1-.72.72c-.31.25-.7.53-1.17.85l-2.32 1.56a8.13 8.13 0 0 0-2.7 2.76 6.74 6.74 0 0 0-.82 3.29v1.86a.41.41 0 0 0 .14.31.46.46 0 0 0 .32.13h9.13a.49.49 0 0 0 .32-.11.37.37 0 0 0 .14-.3v-1a.34.34 0 0 0-.14-.29.52.52 0 0 0-.32-.1h-7.75v-.5a5.75 5.75 0 0 1 .24-1.37 4.17 4.17 0 0 1 .51-1.18 5.41 5.41 0 0 1 1-1.14 13.87 13.87 0 0 1 1.49-1.21l2.21-1.5a8.57 8.57 0 0 0 2.3-2.08 4 4 0 0 0 .69-2.36m9.8-3.52a.39.39 0 0 0-.44-.44h-1.42l-3.45.48a.28.28 0 0 0-.25.3v1.17a.21.21 0 0 0 .21.25h.2l3.07-.38V99.5a.49.49 0 0 0 .11.32.37.37 0 0 0 .3.14h1.26a.37.37 0 0 0 .3-.14.49.49 0 0 0 .11-.32V83.31zM156.71 105.75c.5.37.77.58 1 .43a.38.38 0 0 0 .1-.48 4.6 4.6 0 0 0-1.8-1.88 23.32 23.32 0 0 0-2.9-1.45l-.37-.16-.42-6.21a31.23 31.23 0 0 0 4.42-1.87 2.06 2.06 0 0 0 1.25-2 1.86 1.86 0 0 0-1.55-1.52 40.68 40.68 0 0 0-4.53-1.21l-.14-2.51-.16-2.59 1.45-.52c.85-.3 1.66-.58 2.13-.8a4.76 4.76 0 0 0 2.23-1.68.88.88 0 0 0 .09-.8l-.19-.1a.83.83 0 0 0-.4.2l-.21.14-.54.3c-.3.17-.59.33-.83.44-.72.34-1.84.78-3.83 1.49l-.16-2.51a.23.23 0 0 0-.19-.21 1.2 1.2 0 0 0-.46 0 .24.24 0 0 0-.17.26l.17 2.68c-1.51.51-4.9 1.72-5.91 2.58a1.82 1.82 0 0 0-.71 1.3 1.48 1.48 0 0 0 .49 1.1 8.52 8.52 0 0 0 3.06 1.53l.55.19c.79.25 1.61.43 2.4.61l.57.13.29 4.37c-1.6.64-2.86 1.2-4.18 1.87 0 0-2.15 1.07-2.12 2.5 0 .55.33 1.35 1.74 2 .89.4 2.54 1 4 1.55l1.1.41c0 .52.21 3.49.26 4a.24.24 0 0 0 .25.27.93.93 0 0 0 .25 0h.15a.22.22 0 0 0 .17-.27c-.07-1.08-.19-3-.23-3.66a27.32 27.32 0 0 1 2.68 1.33 11.39 11.39 0 0 1 1.22.83m-4.85-3.87c-1.22-.43-3.07-1.14-4.44-1.76-.81-.36-1-.59-.95-.85a1.84 1.84 0 0 1 .93-1 29.27 29.27 0 0 1 4.11-2c.05.68.22 3.51.34 5.54m.15-11a27.4 27.4 0 0 1 3.92 1 .94.94 0 0 1 .7.64.84.84 0 0 1-.58.65 37.39 37.39 0 0 1-3.79 1.58l-.17-2.93zm-6.09-4.24a38 38 0 0 1 4.86-2l.31 4.68a16.32 16.32 0 0 1-5.14-1.7l-.13-.08a.54.54 0 0 1-.36-.44.85.85 0 0 1 .45-.46m16.19 9.11c-.17.3-.32.56-.42.75a2.8 2.8 0 0 0-.2 1.72 13 13 0 0 0 .51 1.47 10.16 10.16 0 0 1 .44 1.22 6.22 6.22 0 0 1-.43 2.79c-.54 1.39-1.15 2.69-1.26 2.93-.45.94-1.21 2.5-2 3.91-.47.85-.79 1.44-1.2 2.1a10.47 10.47 0 0 1-.9 1.26.54.54 0 0 1-.37.22 2.07 2.07 0 0 1-.45-.06l-.14-.12v-.19c.57-1 1-1.83 1.38-2.59l.73-1.37c.49-.92 2-4.38 2.32-5.11l.15-.4a10.22 10.22 0 0 0 .84-2.83 5.41 5.41 0 0 0-.56-1.71c-.09-.19-.16-.35-.21-.47a4.24 4.24 0 0 1-.21-2.63 5.72 5.72 0 0 1 .63-1.53l.32-.57a9 9 0 0 0 1.18-2.78 6 6 0 0 0 .11-3.07 5.21 5.21 0 0 0-.65-1.45 5.83 5.83 0 0 1-.72-1.59 3.61 3.61 0 0 1 0-1.66c.15-.72.89-3.17.93-3.27a9.13 9.13 0 0 0 .37-2.23 4.59 4.59 0 0 0-.34-2.07 9.69 9.69 0 0 0-1.09-2.16 14.47 14.47 0 0 0-1.39-1.79 9.67 9.67 0 0 0-2.9-2.33c-.5-.24-1.44-.45-1.81 0a1 1 0 0 0 .33 1l.29.34a12.06 12.06 0 0 1 1.82 2.51 3.57 3.57 0 0 1-.48 3.14 4.09 4.09 0 0 1-3.37 2.07 4.44 4.44 0 0 1-2.45-1.1 5.36 5.36 0 0 0-2-1.23h-.21a1.07 1.07 0 0 1-.5-.06l-.2-.18a.34.34 0 0 1 .1-.29 1.5 1.5 0 0 1 1-.4 2.13 2.13 0 0 1 1 .31c.26.16.54.37.84.6a4.41 4.41 0 0 0 2.61 1c1.26 0 2.37-1.64 2.49-2.22.18-.91-.18-1.77-1.2-2.89a6.85 6.85 0 0 1-1-1.43 1.67 1.67 0 0 1 0-1.85c.65-.93 2.54-.86 3.72-.18a12 12 0 0 1 2.5 1.92 18.67 18.67 0 0 1 1.46 1.71l.2.25a12 12 0 0 1 1.84 3.93 5.57 5.57 0 0 1 .11 2 6.27 6.27 0 0 1-.17 1l-.12.52c-.14.56-.29 1.09-.44 1.6s-.28 1-.41 1.49c-.31 1.23-.27 1.44.72 3.13a4.65 4.65 0 0 1 .73 2.24 9.93 9.93 0 0 1-.77 4.48 15.87 15.87 0 0 1-1.07 2.1m-14.06 18a.45.45 0 0 1 0 .35l-.13.1h-.12a.82.82 0 0 1-.65-.23c-.33-.61-.82-1.51-1.51-2.74l-1.14-1.93c-.47-.84-1-1.66-1.47-2.46l-.32-.51c-.74-1.2-1.35-2.29-1.93-3.41a8.2 8.2 0 0 1-1.08-3.56 9.43 9.43 0 0 1 .62-3.2 3.51 3.51 0 0 0 0-3.3l-.11-.2a16.75 16.75 0 0 1-1.55-3.42 8.4 8.4 0 0 1-.19-2.25 23.81 23.81 0 0 1 .66-4.69c0-.18.09-.37.13-.55a28.08 28.08 0 0 1 2-5.44 27.11 27.11 0 0 1 1.6-2.63 9.65 9.65 0 0 1 1.68-1.88 6.66 6.66 0 0 1 4-2 5.71 5.71 0 0 1 3 .91 6.62 6.62 0 0 1 2.8 3.43 2.13 2.13 0 0 1-.06 1.39 1.35 1.35 0 0 1-1.11 1.08c-1.32.25-2.45-1.53-3.95-2.11a.37.37 0 0 1-.22-.36.31.31 0 0 1 .17-.27 1.14 1.14 0 0 1 .89-.08 3.12 3.12 0 0 1 1.22.79 2 2 0 0 0 1.47.77.49.49 0 0 0 .32-.24 1.08 1.08 0 0 0 0-.83 4 4 0 0 0-1-1.49 5 5 0 0 0-2.22-1.5 3.48 3.48 0 0 0-3.3.65 11.34 11.34 0 0 0-2.38 2.34 20.94 20.94 0 0 0-2.27 3.81 24.78 24.78 0 0 0-1.37 4.28 23.49 23.49 0 0 0-.71 4.93 7.06 7.06 0 0 0 .92 3.67c.12.24.26.48.4.73a6.79 6.79 0 0 1 .88 2 5.54 5.54 0 0 1-.37 2.67 9.14 9.14 0 0 0-.53 3 9.55 9.55 0 0 0 1.45 4l.18.31c.48.87 1.38 2.45 1.65 2.92l.1.17c.58 1 1.14 2 1.68 3l.4.77c.33.62.66 1.27 1 1.94 0 0 .3.77.48 1.24zM287.64 26.39a217.57 217.57 0 0 0-6.05-25 .84.84 0 0 0-.8-.59H255a.84.84 0 0 0-.82.61q-6.57 22.81-8.5 55.59a.43.43 0 0 0 .43.46h7.17a.28.28 0 0 0 .28-.25 124.3 124.3 0 0 1 1.91-12.53 88 88 0 0 1 25.49-3q2.71 13.49 3 15.59a.28.28 0 0 0 .28.24h7.16a.43.43 0 0 0 .43-.46 296.88 296.88 0 0 0-4.2-30.6M271 8.86c.82 1.86 1.6 3.74 2.26 5.66 1.7 4.9 4 12.35 5.74 18.93h-21.16q2.82-11.81 6.46-23zm-38.15-5.77a.89.89 0 0 0-.45-.26A76.79 76.79 0 0 0 217.95.89Q215.14.75 201.1.74a.86.86 0 0 0-.86.9l3 55a.85.85 0 0 0 .85.81h26.27a.86.86 0 0 0 .79-.54q9.6-23.46 11.75-38.35a1.73 1.73 0 0 0-.14-1 54 54 0 0 0-9.86-14.5m-6.5 42.76A36.83 36.83 0 0 1 211 49l1-40.13q14.19.45 19.47 9.36.22 11.67-5.13 27.65M194.16 1.25L192 8.15a.42.42 0 0 1-.39.29A87.12 87.12 0 0 0 171 11.25a60.6 60.6 0 0 0-2.82 13.25h22.44a.43.43 0 0 1 .4.56l-2 6.36a.43.43 0 0 1-.37.29q-13.86 1.18-21 3.46a35.76 35.76 0 0 0 1 10.07q3.18 2.3 10 3.66a74 74 0 0 0 14.19 1.37.42.42 0 0 1 .41.55l-2 6.36a.42.42 0 0 1-.37.3q-3.95.27-8.52.28Q170.68 57.74 164 56a1.65 1.65 0 0 1-1.06-.85q-5.58-11-5.58-31a100 100 0 0 1 1.88-20.34 1.67 1.67 0 0 1 1.06-1.23Q167.46 0 179.44 0q6.72 0 14.35.69a.43.43 0 0 1 .37.56m-68.62-.5h8.31a.42.42 0 0 1 .41.31l3.74 13.5a1.71 1.71 0 0 1 .06.62l-3 31.94 19.35 2.42a.43.43 0 0 1 .35.29l2.2 7.06a.42.42 0 0 1-.4.55h-29.33a.42.42 0 0 1-.43-.44l-1.68-55.81a.43.43 0 0 1 .43-.44m-5.66.5l-2.19 6.91a.42.42 0 0 1-.39.29 87.13 87.13 0 0 0-20.57 2.81 60.6 60.6 0 0 0-2.83 13.24h22.44a.43.43 0 0 1 .4.56l-2 6.36a.43.43 0 0 1-.37.29q-13.85 1.18-21 3.46a35.79 35.79 0 0 0 1 10.07q3.18 2.3 10 3.66a74 74 0 0 0 14.19 1.37.42.42 0 0 1 .4.55l-2 6.36a.43.43 0 0 1-.37.3q-4 .27-8.52.28-11.64 0-18.3-1.73a1.67 1.67 0 0 1-1.07-.86q-5.58-11-5.57-31A100 100 0 0 1 85 3.8a1.68 1.68 0 0 1 1.07-1.24Q93.18 0 105.16 0q6.72 0 14.35.69a.43.43 0 0 1 .37.56m-39.95.86a.42.42 0 0 1 .34.54L64.41 56.23a1.7 1.7 0 0 1-1.63 1.22H47.21a1.7 1.7 0 0 1-1.69-1.52L41.08 15a22.42 22.42 0 0 0-2.74-1L30.9 56a1.7 1.7 0 0 1-1.67 1.41H16.09a1.71 1.71 0 0 1-1.63-1.19A504.08 504.08 0 0 1 0 1.26.43.43 0 0 1 .43.75h11.7a.42.42 0 0 1 .42.38 343.14 343.14 0 0 0 8.22 46.09 28 28 0 0 0 4-1.52l3.34-40.34a.85.85 0 0 1 .76-.78l19.48-2.1a.85.85 0 0 1 .94.76l4.43 45.12a28.11 28.11 0 0 0 4.53.57l5.19-34.28a1.72 1.72 0 0 1 .18-.55L70.63 1a.42.42 0 0 1 .44-.2l8.87 1.31"/></g></svg>'};

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1400 8192"><path fill="none" stroke="#DFC3C3" stroke-width="10" stroke-linecap="round" stroke-dasharray="2" d="M862.3 0s58.5 33.1 100 103.6 18.5 146.2-78.6 187.5c-117.6 50.1-226.9 96-226.8 201.2.2 186.7 375.8 313.2 454.8 472.6 130.9 264.1-202 429.1-410.7 520.9s-531.7 179.1-483.4 425.6c35.9 183 385.5 211.3 482.2 215.6 15.7.7 49.8 3.3 63.5 5.1 139.4 17.8 345.8 68.6 373.2 208.2 48.4 246.6-274.7 333.9-483.4 425.6s-541.6 256.7-410.7 520.9c79 159.4 454.5 285.9 454.8 472.6.1 105.2-109.2 151.1-226.8 201.2-97 41.3-120.1 117-78.6 187.5s97.4 100.1 97.4 100.1l15.1 6.7c117.6 50.1 227 98.5 226.9 203.6-.2 186.7-375.8 313.2-454.8 472.6-130.9 264.1 202 429.1 410.7 520.9 208.6 91.7 531.7 179.1 483.4 425.6-27.4 139.5-233.7 190.4-373.2 208.2-13.7 1.7-47.9 4.4-63.5 5.1-96.7 4.3-446.3 32.6-482.2 215.6-48.4 246.6 274.7 333.9 483.4 425.6s541.6 256.7 410.7 520.9c-79 159.4-454.5 285.9-454.8 472.6-.1 105.2 109.2 151.2 226.8 201.2 97 41.3 120.1 117 78.6 187.5s-100 103.6-100 103.6"/><image class="ap" width="62" height="62" xlink:href="../../../static/img/ap.png" transform="translate(0 1)" overflow="visible"/></svg>'};

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 95"><path class="st0" d="M93 8.5v27.8h-4.6V16.5L53.1 51.7l-3.3-3.3 35.3-35.3H65.6V8.5H93zm-4.6 41.6V87H14.6V13.2h36.9V8.5H9.9v83.1H93V50.1h-4.6z" stroke="#000" stroke-width="2" stroke-miterlimit="10"/></svg>'};

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {template: '<svg data-name="Слой 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 87.41"><title>social</title><path d="M70.62 0A26 26 0 0 0 50 9.56 26 26 0 0 0 29.38 0C11.81 0 0 16.28 0 31.48c0 22.13 42.52 51.8 47.37 55.11a4.68 4.68 0 0 0 5.27 0c4.85-3.31 47.37-33 47.37-55.11C100 16.28 88.19 0 70.62 0zM50 77.04C33.26 65.13 9.34 43.82 9.34 31.48c0-9.28 7-22.14 20-22.14 11.89 0 16.09 10.27 16.25 10.68a4.67 4.67 0 0 0 4.34 3 4.7 4.7 0 0 0 4.35-3c.17-.44 4.37-10.71 16.26-10.71 13.07 0 20 12.86 20 22.14.12 12.35-23.8 33.67-40.54 45.59z"/></svg>'};

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"/></svg>'};

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.635 10.909v2.619h4.335c-.173 1.125-1.31 3.295-4.331 3.295-2.604 0-4.731-2.16-4.731-4.823 0-2.662 2.122-4.822 4.728-4.822 1.485 0 2.479.633 3.045 1.178l2.073-1.994c-1.33-1.245-3.056-1.995-5.115-1.995C3.412 4.365 0 7.785 0 12s3.414 7.635 7.635 7.635c4.41 0 7.332-3.098 7.332-7.461a6.96 6.96 0 0 0-.12-1.265H7.635zm16.365 0h-2.183V8.726h-2.183v2.183h-2.182v2.181h2.184v2.184h2.189V13.09H24"/></svg>'};

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.505 17.44a11.599 11.599 0 0 0 3.6-1.49 1.816 1.816 0 0 0-1.935-3.073 7.866 7.866 0 0 1-8.34 0 1.814 1.814 0 0 0-2.5.565c0 .002 0 .004-.002.005a1.812 1.812 0 0 0 .567 2.5l.002.002c1.105.695 2.322 1.2 3.596 1.488l-3.465 3.465A1.796 1.796 0 0 0 6 23.439l.03.03c.344.354.81.53 1.274.53.465 0 .93-.176 1.275-.53L12 20.065l3.404 3.406a1.815 1.815 0 0 0 2.566-2.565l-3.465-3.466zM12 12.388a6.202 6.202 0 0 0 6.195-6.193C18.195 2.78 15.415 0 12 0S5.805 2.78 5.805 6.197A6.2 6.2 0 0 0 12 12.389zm0-8.757a2.566 2.566 0 0 1 0 5.13 2.569 2.569 0 0 1-2.565-2.564A2.57 2.57 0 0 1 12 3.63z"/></svg>'};

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.954 4.569a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.691 8.094 4.066 6.13 1.64 3.161a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.061a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"/></svg>'};

/***/ }),
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./fb-new.svg": 126,
	"./fb.svg": 564,
	"./googleplus.svg": 565,
	"./ok.svg": 566,
	"./tw.svg": 567,
	"./vk.svg": 127
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
module.exports = __webpack_require__(181);


/***/ })
],[572]);


// WEBPACK FOOTER //
// static/js/app.js